import * as React from 'react';
import { BookingDetailSection, SectionProps } from '../../SharedSections/BookingDetailSection';
import { BookingSummaryAddon } from '../../../../BookingSummaryDto';
import { EditType } from '../../BookingDetailedView';
import { isNotNullOrUndefined } from 'Util/TypeGuards';
import { useIntl } from 'react-intl';

export function AdditionalBookingOptionsInfoSection({ booking, canEdit, onEdit, isInvoiced }: SectionProps) {
	const intl = useIntl();

	if (!booking.bookedSummary) {
		console.error('Booked summary missing, this should not happen');
		return <></>;
	}

	if (
		!(
			isNotNullOrUndefined(booking.bookedSummary.additionalBookingOptions) &&
			booking.bookedSummary.additionalBookingOptions.filter(x => x.quantity > 0).length > 0
		)
	) {
		return null;
	}

	const showEditBtn = canEdit && !isInvoiced;

	const editType: EditType = 'add-on';

	if (booking.bookedSummary.additionalBookingOptions?.length !== undefined) {
		const sectionContent = (
			<p className="additional-booking-items">
				{booking.bookedSummary.additionalBookingOptions
					?.filter((x: BookingSummaryAddon) => x.quantity > 0)
					.map((additionalItem: BookingSummaryAddon) => {
						return (
							<p className="additional-option-line-item" key={additionalItem.option?.id}>
								{additionalItem.quantity}x {additionalItem.option?.name}
							</p>
						);
					})}
			</p>
		);

		return (
			<BookingDetailSection
				sectionName={intl.formatMessage({
					id: 'booking-details__add-ons-section__label',
					defaultMessage: 'Add ons',
				})}
				sectionContent={sectionContent}
				sectionClassName="additional-booking-items"
				icon={{
					name: 'style',
					useMaterialIcons: true,
				}}
				modificationRules={{
					canEdit: showEditBtn,
					editType: editType,
					onEdit: onEdit,
					isInvoiced: isInvoiced,
				}}
			/>
		);
	}
	return <></>;
}
